import React from 'react';

const RightArrow = () => (
  <svg
    width="12"
    height="21"
    viewBox="0 0 12 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="rightArrow"
  >
    <path
      d="M1.88739 20.4502L0.5 19.0069L8.72522 10.4502L0.5 1.89349L1.88739 0.450195L11.5 10.4502L1.88739 20.4502Z"
      fill="#323232"
    />
  </svg>
);

export default RightArrow;
